export default __webpack_public_path__ + "static/media/bottom-banner.eeed8d9e.png";